/**
 * External dependencies
 */
import { some } from 'lodash';

/**
 * Internal dependencies
 */
import getLocation from './get-location';
import getEdits from './get-edits';

export default (state, locationId) => {
     
    const location = getLocation(state, locationId);
    const edits = getEdits(state, locationId);

    if (!edits) {
        return false;
    }
   
    if (!location && edits) {
        return true;
    }

    if (!location) {
        return false;
    }

    const editsDirty = some(edits, (value, key) => {
        return location[key] !== value;
    });

    return editsDirty;
};